import { Theme } from './theme'

const splitSegments = (segment) => {
  return [segment.charAt(0), segment.substring(1, segment.length)]
}

const convertArrayToCss = (array) => {
  let result = ''
  for (const i in array) {
    if (array[i] === 0) {
      result += '0 '
    } else {
      result += `${array[i]}rem `
    }
  }
  result += ';'
  return result
}

export const isExpertContributed = (contributors) => {
  return contributors.some((contributor) => 
    contributor.status === "published" && contributor.title !== "Priyaanka Arora"
  )
}

export const parseMarginOrPadding = (margin, base = null) => {
  // margin = l5 r5 b2
  if (!margin) {
    if (base) return base
    else return undefined
  }
  if(base) {
    base = base.replace(/px|rem/g, "")
  }
  const segments = margin.match(/([ltbr]|[LTBR])-?\d+\.?\d*/g)
  const result = [0, 0, 0, 0]
  if (base && base.split(' ').length === 4) {
    base = base.split(' ')
    result[0] = base[0]
    result[1] = base[1]
    result[2] = base[2]
    result[3] = base[3]
  }
  if (segments) {
    for (const i in segments) {
      const segment = segments[i]
      const [direction, value] = splitSegments(segment)

      switch (direction.toLowerCase()) {
        case 't':
          result[0] = value
          break
        case 'r':
          result[1] = value
          break
        case 'b':
          result[2] = value
          break
        case 'l':
          result[3] = value
          break
        default:
          console.error('Incorrect margin value')
      }
    }
    return convertArrayToCss(result)
  } else {
    margin = margin.split(' ')
    if (margin.length === 3) console.error('Margin has 3 unknown values')
    return convertArrayToCss(margin)
  }
}

export const getColor = (props) => {
  if (props.background) return props.theme.colors.onBackground
  if (props.surface) return props.theme.colors.onSurface
  if (props.primary) return props.theme.colors.onPrimary
  if (props.secondary) return props.theme.colors.onSecondary
  if (props.error) return props.theme.colors.onError
  return props.theme.colors.onBackground
}

export const getBackgroundColor = (props) => {
  if (props.background) return props.theme.colors.background
  if (props.surface) return props.theme.colors.surface
  if (props.primary) return props.theme.colors.primary
  if (props.secondary) return props.theme.colors.secondary
  if (props.error) return props.theme.colors.error
  return props.theme.colors.primary
}

export const getLevel = (props) => {
  if (props.h1) return 'h1'
  if (props.h2) return 'h2'
  if (props.h3) return 'h3'
  if (props.h4) return 'h4'
  if (props.h5) return 'h5'
  return 'h1'
}

export const divByRem = (px) => {
  return px / Theme.typography.global.rem
}

export function shadeColor(colorCode, amount) {
  let usePound = false

  if (colorCode[0] == '#') {
    colorCode = colorCode.slice(1)
    usePound = true
  }

  const num = parseInt(colorCode, 16)

  let r = (num >> 16) + amount

  if (r > 255) {
    r = 255
  } else if (r < 0) {
    r = 0
  }

  let b = ((num >> 8) & 0x00ff) + amount

  if (b > 255) {
    b = 255
  } else if (b < 0) {
    b = 0
  }

  let g = (num & 0x0000ff) + amount

  if (g > 255) {
    g = 255
  } else if (g < 0) {
    g = 0
  }

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
}

export function shade(hex, percent = 100) {
  if (hex.charAt(0) == '#') hex = hex.substring(1)
  let r = hex[0] + hex[1]
  let g = hex[2] + hex[3]
  let b = hex[4] + hex[5]
  r = parseInt(r, 16)
  g = parseInt(g, 16)
  b = parseInt(b, 16)
  let max = Math.max(r, g)
  max = Math.max(max, b)

  let hexPercent = (percent * max) / 100
  hexPercent = Math.floor(hexPercent)
  const hexVal = parseInt(hexPercent, 16)

  r = r - hexVal
  if (r <= 0x00) r = '00'
  else if (r < 0x10) r = '0' + r.toString(16)
  else r = r.toString(16)

  g = g - hexVal
  if (g <= 0x00) g = '00'
  else if (g < 0x10) g = '0' + g.toString(16)
  else g = g.toString(16)

  b = b - hexVal
  if (b <= 0x00) b = '00'
  else if (b < 0x10) b = '0' + b.toString(16)
  else b = b.toString(16)

  return '#' + r + g + b
}

export const getPageUrl = (path) => {
  if (!path) return '/'
  if (path.alias) {
    if (path.alias.charAt(path.alias.length - 1) === '/') {
      return path.alias.slice(0, -1)
    } else {
      return path.alias
    }
  } else {
    return `/node/${path.pid}`
  }
}
